import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class SetParamRequest extends Request {
    constructor(paramId, paramValue) {
        super({
            req: RequestTypes.SET_PARAM,
            req_id: 0,
            param_id: paramId,
            param_value: paramValue
        });
    }
}

export default SetParamRequest;